import "./TermsAndConditions.module.css";
import Header from "@/reusable_sections/Header";
import WelcomeToOurTermsAndConditions from "./sections/WelcomeToOurTermsAndConditions";
import YourAgreementWithUs from "./sections/YourAgreementWithUs";
import NeedMoreInformation from "./sections/NeedMoreInformation";
import Footer from "@/reusable_sections/Footer";
export default function TermsAndConditionsPage() {
  return <div>
      <Header />
      <WelcomeToOurTermsAndConditions />
      <YourAgreementWithUs />
      <NeedMoreInformation />
      <Footer />
    </div>;
}